module.exports = __webpack_public_path__ + "static/media/hulu-logo.63df8c19.png";